import { FaCheck } from "react-icons/fa";

const features = [
  "Structured pitch templates: Problem, Solution, Traction, GTM & more",
  "Quick export to Google Slides",
  "Built for fast fundraising workflows",
  "Suitable for pre-seed and seed early-stage startups",
  "Trusted by 5,000+ founders and accelerators",
];

export default function PitchZynth() {
  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center bg-gradient-to-br from-blue-50 via-white to-blue-100 px-4 py-10">
      <div className="w-full flex flex-col md:flex-row items-center justify-center gap-10 md:gap-16">
        <div className="w-full md:w-[60%] flex justify-center">
          <div className="relative w-full max-w-[500px] aspect-square">
            <div className="pentagon pentagon-blue w-full h-full flex items-center justify-center z-10">
              <div className="pentagon pentagon-white w-[98%] h-[98%] flex items-center justify-center z-20">
                <div className="pentagon pentagon-purple w-[98%] h-[98%] flex items-center justify-center z-30">
                  <div className="pentagon pentagon-white w-[98%] h-[98%] flex items-center justify-center z-40">
                    <div className="pentagon pentagon-green w-[98%] h-[98%] flex items-center justify-center z-50">
                      <div className="pentagon pentagon-white w-[97%] h-[97%] flex items-center justify-center z-60">
                        <div className="pentagon bg-white w-[90%] h-[90%] sm:w-[88%] sm:h-[88%] shadow-md flex items-center justify-center text-center px-6 py-8 z-70">
                          <div>
                            <div className="text-xs sm:text-base text-gray-500 mb-2 mt-4 sm:mt-2">
                              Pitch.zynth.ai
                            </div>
                            <h1 className="text-lg sm:text-xl md:text-3xl font-bold mb-4 px-8 sm:px-0">
                              AI Pitch Deck Creator
                            </h1>
                            <p className="text-gray-700 text-xs sm:text-sm">
                              The ultimate AI pitch deck builder for startups
                              and founders. Pitch.zynth.ai is a dedicated
                              presentation generator to create investor-ready
                              pitch decks with the help of AI.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full md:w-1/2 px-4">
          <ul className="space-y-4 mb-4">
            {features.map((item, idx) => (
              <li
                key={idx}
                className="flex items-start gap-4 border-b pb-1 border-gray-300 last:border-none"
              >
                <div className="flex-shrink-0 h-5 w-5 mt-[2px] text-green-600">
                  <FaCheck className="w-full h-full" />
                </div>
                <span className="text-gray-800 text-md sm:text-lg">{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-10">
        <button 
        onClick={()=>{
            window.open(
                "https://pitch.zynth.ai/",
                "_blank"
            )
        }}
        className="px-6 py-3 bg-[#3667B2] hover:bg-blue-700 text-white rounded-md text-lg font-medium"
        >
          Generate Pitch Deck
        </button>
      </div>
    </div>
  );
}
